import { CreditCard, Package, Globe, Award, Leaf, Zap } from 'lucide-react';

const Features = () => {
  const features = [
    {
      icon: CreditCard,
      title: 'No Upfront Costs',
      description:
        'Start your brand with zero inventory investment. Pay only when you make a sale.',
    },
    {
      icon: Package,
      title: 'No Minimum Orders',
      description:
        'Order one item or thousands. Perfect for testing designs or scaling your business.',
    },
    {
      icon: Globe,
      title: 'Global Shipping',
      description:
        'We ship worldwide with fast delivery from our strategically located fulfillment centers.',
    },
    {
      icon: Award,
      title: 'Premium Quality',
      description:
        'Industry-leading print quality on carefully curated premium blank products.',
    },
    {
      icon: Leaf,
      title: 'Eco-Friendly',
      description:
        'Sustainable packaging and water-based inks that are better for the environment.',
    },
    {
      icon: Zap,
      title: 'Fast Production',
      description:
        'Most orders ship within 2-4 business days with real-time tracking.',
    },
  ];

  return (
    <section
      data-testid="features-section"
      className="py-24 md:py-32 bg-white"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          {/* Left - Image */}
          <div
            data-testid="features-image"
            className="relative order-2 lg:order-1"
          >
            <div className="relative rounded-3xl overflow-hidden shadow-2xl">
              <img
                src="https://images.unsplash.com/photo-1766040923580-16ad32fae8b4?w=800&h=600&fit=crop"
                alt="Fulfillment warehouse"
                className="w-full h-auto object-cover"
              />
              {/* Overlay gradient */}
              <div className="absolute inset-0 bg-gradient-to-tr from-coastal-navy/20 to-transparent" />
            </div>

            {/* Stats Card */}
            <div className="absolute -bottom-6 -right-6 bg-white rounded-2xl p-6 shadow-xl border border-gray-100">
              <div className="flex items-center gap-4">
                <div className="w-14 h-14 bg-coastal-orange/10 rounded-xl flex items-center justify-center">
                  <Globe className="w-7 h-7 text-coastal-orange" />
                </div>
                <div>
                  <p className="text-2xl font-heading font-bold text-coastal-navy">
                    150+
                  </p>
                  <p className="text-sm text-gray-500">Countries Served</p>
                </div>
              </div>
            </div>
          </div>

          {/* Right - Content */}
          <div className="order-1 lg:order-2">
            <h2
              data-testid="features-heading"
              className="font-heading text-3xl md:text-4xl lg:text-5xl tracking-tight font-bold text-coastal-navy mb-6"
            >
              Why choose{' '}
              <span className="text-coastal-orange">Coastal Route?</span>
            </h2>
            <p className="text-lg text-gray-600 leading-relaxed mb-10">
              We combine premium materials and state-of-the-art production
              processes to ensure exceptional quality at every step.
            </p>

            {/* Features Grid */}
            <div
              data-testid="features-grid"
              className="grid sm:grid-cols-2 gap-6"
            >
              {features.map((feature, index) => {
                const Icon = feature.icon;

                return (
                  <div
                    key={index}
                    data-testid={`feature-${index}`}
                    className="group flex gap-4"
                  >
                    <div className="flex-shrink-0 w-12 h-12 bg-coastal-offwhite rounded-xl flex items-center justify-center group-hover:bg-coastal-orange/10 transition-colors">
                      <Icon className="w-6 h-6 text-coastal-navy group-hover:text-coastal-orange transition-colors" />
                    </div>
                    <div>
                      <h3 className="font-heading font-semibold text-coastal-navy mb-1">
                        {feature.title}
                      </h3>
                      <p className="text-sm text-gray-600 leading-relaxed">
                        {feature.description}
                      </p>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Features;
